import { getToken } from "@firebase/messaging";
import { messaging } from "../firebase";

export const requestFirebaseNotificationToken = async () => {

    try {
        const permission = await Notification.requestPermission();

        if (permission === "granted") {
            const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');

            if (!registration) {
                throw new Error("Service worker registration failed or returned undefined");
            }
            await navigator.serviceWorker.ready;
            const token = await getToken(messaging, {
                vapidKey: "BFWRm9gIQcn6q2DIpb5-jytU2UWBaXrOzJWqZooJwuOM_-k2r9SDuXtLbtoXpf6IR3QzAI9xDt2bOS10CZiUd10",
                serviceWorkerRegistration: registration,
            });
            
            return token;
        } else {
            console.warn("Notification permission denied.");
        }
    } catch (err) {
        console.error("FCM token error", err);
    }
}